import React from 'react';

import { Flex } from '@adsk/alloy-react-box';
import ProgressRing from '@adsk/alloy-react-progress-ring';

const ReferencePickerLoader: React.FC<{
  style?: React.CSSProperties;
  className?: string;
}> = ({ style, className }) => {
  return (
    <Flex
      justifyContent="center"
      padding="24px"
      className={className}
      style={style}
    >
      <ProgressRing size={ProgressRing.SIZES.SMALL} />
    </Flex>
  );
};

export default ReferencePickerLoader;
